import { lazy } from "react";

const MainLayout = lazy(() => import("../layouts/MainLayout"));
const Accueil = lazy(() => import("../pages/Accueil"));
const Concept = lazy(() => import("../pages/Concept"));
const Formules = lazy(() => import("../pages/Formules"));
const Formule = lazy(() => import("../pages/Formule"));
const MiniCaravanes = lazy(() => import("../pages/MiniCaravanes"));
const Caravane = lazy(() => import("../pages/Caravane"));
const Reservations = lazy(() => import("../pages/Reservation"));
const SurMesure = lazy(() => import("../pages/SurMesure"));
const SuccesPaiementReservation = lazy(() =>
    import("../pages/SuccesPaiementReservation")
);
const AnnulationPaiementReservation = lazy(() =>
    import("../pages/AnnulationPaiementReservation")
);
const Experiences = lazy(() => import("../pages/Experiences"));
const Histoire = lazy(() => import("../pages/Histoire"));
const Contact = lazy(() => import("../pages/Contact"));
const Actualites = lazy(() => import("../pages/Actualites"));   
const UneActualite = lazy(() => import("../pages/Actualite"));
const Departements = lazy(() => import("../pages/Departements"));
const Departement = lazy(() => import("../pages/Departement"));
const Thematiques = lazy(() => import("../pages/Thematiques"));
const Thematique = lazy(() => import("../pages/Thematique"));
const Documentation = lazy(() => import("../pages/Documentation"));
const Reglementation = lazy(() => import("../pages/Reglementation"));
const Faq = lazy(() => import("../pages/Faq"));
const Partenaires = lazy(() => import("../pages/Partenaires"));
const MentionLegal = lazy(() => import("../pages/MentionLegal"));
const CGV = lazy(() => import("../pages/CGV"));
const PolitiqueConf = lazy(() => import("../pages/PolitiqueConf"));
const Error = lazy(() => import("../pages/Error")); 
const BonCadeaux = lazy(() => import("../pages/BonCadeaux"));

const MembersRoutes = {
  element: <MainLayout />,
  children: [
    {
      path: "/",
      element: <Accueil />,
    },
    {
      path: "/concept",
      element: <Concept />,
    },
    {
      path: "/formules",
      element: <Formules />,
    },
    {
      path: "/formule/:slug",
      element: <Formule />,
    },
    {
      path: "mini-caravanes",
      element: <MiniCaravanes />,
    },
    {
      path: "mini-caravanes/:slug",
      element: <Caravane />,
    },
    {
      path: "reservation",
      element: <Reservations />,
    },
    {
      path: "formule-sur-mesure",
      element: <SurMesure />,
    },
    {
      path: "succes-paiement-reservation/:ref",
      element: <SuccesPaiementReservation />,
    },
    {
      path: "annulation-paiement-reservation/:ref",
      element: <AnnulationPaiementReservation />,
    },
    {
      path: "experiences",
      element: <Experiences />,
    },
    {
      path: "histoire",
      element: <Histoire />,
    },
    {
      path: "contact",
      element: <Contact />,
    },
    {
      path: "bons-cadeaux",
      element: <BonCadeaux />,
    },
    {
      path: "actualites",
      element: <Actualites />,
    },
    {
      path: "actualite/:slug",
      element: <UneActualite />,
    },
    {
      path: "departements",
      element: <Departements />,
    },
    {
      path: "departement",
      element: <Departement />,
    },
    {
      path: "thematiques",
      element: <Thematiques />,
    },
    {
      path: "thematique/:slug",
      element: <Thematique />,
    },
    {
      path: "documentation",
      element: <Documentation />,
    },
    {
      path: "reglementation",
      element: <Reglementation />,
    },
    {
      path: "faq",
      element: <Faq />,
    },
    {
      path: "partenaires",
      element: <Partenaires />,
    },
    {
      path: "mentions-legales",
      element: <MentionLegal />,
    },
    {
      path: "conditions-generales-de-vente",
      element: <CGV />,
    },
    {
      path: "politique-de-confidentialite",
      element: <PolitiqueConf />,
    },
    {
      path: "*",
      element: <Error />,
    },
  ],
};

export default MembersRoutes;